import { createApp } from 'vue';
import { auth } from '@/utils/firebase';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import useState from './store';
import  VueGoogleMaps from '@fawmi/vue-google-maps'

const googleMapsOptions = {
	load: {
		key: 'AIzaSyA9I3HXAmcFKRd_AAfRlmHQvkiGaIxu0bE',
	},
	libraries: "places",
};

let app = '';

auth.onAuthStateChanged(async (fbUser) => {
	if (!app) {
		app = createApp(App);
		app.use(router);
		app.use(VueGoogleMaps, googleMapsOptions)
		app.mount('body');

		if (fbUser) {
			const localStorage = JSON.parse(window.localStorage.getItem(fbUser.uid));

			// console.log('USER STATE HAS CHAGED');

			if (localStorage) {
				const { initState } = useState();
				await initState(fbUser.uid);
			} else {
				await auth.signOut();
				await router.push({ name: 'login' });
			}
		}
	}
});
